module.exports = __webpack_public_path__ + "img/T-360_overview_First_Frame.8e0250f3.png";